import { getDashboardState } from '../state/getDashboardState'

export const useAuth = () => {
  let customerAuthenticated = false
  if (typeof window !== 'undefined') {
    const state = getDashboardState()
    customerAuthenticated = !!(state && state.auth && state.auth.jwt)
  }
  return customerAuthenticated
}
